import { Directive, ContentChild, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appCard]'
})
export class CardDirective {
  @ContentChild(TemplateRef) public template: TemplateRef<any>;
}

